export const THOUGHT_LEADER_CATEGORY_ID = 'ipJme86PZN1LzUXbuquH';

export type CompanyType = 'software' | 'service' | 'thoughtLeader' | 'association';

export type CapType =
	| 'products'
	| 'supportedProducts'
	| 'integrators'
	| 'globalRelatedProductsForContent';

type CompanyTypeType = {
	slug: string;
	endpoint: string;
	singular: string;
	plural: string;
	caps: {
		[key in CapType]: boolean;
	};
};

type CompanyTypesType = {
	[slug: string]: CompanyTypeType;
};

export const companyTypes: CompanyTypesType = {
	software: {
		singular: 'Software',
		plural: 'Software',
		slug: 'software',
		endpoint: 'software',
		caps: {
			products: true,
			supportedProducts: false,
			globalRelatedProductsForContent: false,
			integrators: true,
		},
	},
	service: {
		singular: 'Service',
		plural: 'Services',
		slug: 'service',
		endpoint: 'services',
		caps: {
			products: false,
			supportedProducts: true,
			globalRelatedProductsForContent: true,
			integrators: false,
		},
	},
	thoughtLeader: {
		singular: 'Thought Leader',
		plural: 'Thought Leaders',
		slug: 'thoughtLeader',
		endpoint: 'thought-leaders',
		caps: {
			products: false,
			supportedProducts: true,
			globalRelatedProductsForContent: false,
			integrators: false,
		},
	},
	association: {
		singular: 'Association',
		plural: 'Associations',
		slug: 'association',
		endpoint: 'associations',
		caps: {
			products: true,
			supportedProducts: true,
			globalRelatedProductsForContent: false,
			integrators: false,
		},
	},
};

export const getCompanyType = (slug: CompanyType) => {
	try {
		return companyTypes[slug];
	} catch (error: any) {
		console.error(error);
	}
};

export const currentCompanyTypeSupports = (types: CompanyType[], cap: CapType) => {
	try {
		for (const type of types) {
			if (true === companyTypes[type].caps[cap]) {
				return true;
			}
		}

		return false;
	} catch (error: any) {
		console.error(error);
	}
};
